import { render, staticRenderFns } from "./vendor-integration-specification-modal.vue?vue&type=template&id=62513f47&scoped=true&"
import script from "./vendor-integration-specification-modal.vue?vue&type=script&lang=js&"
export * from "./vendor-integration-specification-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62513f47",
  null
  
)

export default component.exports